import { createApp } from 'vue'
import TemperaturaConverter from './TemperaturaConverter.vue'
import './assets/global.css'

createApp(TemperaturaConverter).mount('#temperatura')
